import { Price } from '@vfde-brix/core';
import { ADDITIONAL_PAGE_OPTIONS } from '@vfde-fe/sails-constants';
import {
    TokenGroup,
    updateDynamicValuesInCmsContent,
} from '@vfde-fe/sails_core';
import { StateProps } from '../../DeviceDetail/interface';
import {
    REGEX_ONETIMEFEE,
    REGEX_STAIRWAY_MONTH,
    REGEX_STAIRWAY_PRICE,
} from '../constants';
import {
    calculateMonthlyPriceWithoutStairway,
    hasStairway,
} from './priceHelper';

const composeLegalText = (offer): string => {
    const { legalTextOneTimeFee, noOneTimeFee } = window[ADDITIONAL_PAGE_OPTIONS].offerPrice;
    const legalTextTemplate = [];
    const legalTextTokens: TokenGroup = {};

    if (offer.oneTimeFee?.gross > 0) {
        legalTextTokens.oneTimeFee = {
            regex: REGEX_ONETIMEFEE,
            replacement: offer.oneTimeFee.gross.toLocaleString('de'),
        };
    }

    legalTextTemplate.push(offer.oneTimeFee?.gross > 0 ? legalTextOneTimeFee : noOneTimeFee);

    return updateDynamicValuesInCmsContent(legalTextTemplate.join(' '), legalTextTokens);
};

/**
 * Stairway text
 * @param state
 */
export const composeStairwayText = (state: Partial<StateProps>): string => {
    const { offer } = state;
    const { legalTextStairway } = window[ADDITIONAL_PAGE_OPTIONS].offerPrice;
    const legalTextTokens: TokenGroup = {};

    if (hasStairway(offer)) {
        legalTextTokens.runtime = {
            regex: REGEX_STAIRWAY_MONTH,
            replacement: `${offer.monetary[0].runTimeEnd + 1}`,
        };
        legalTextTokens.stairway = {
            regex: REGEX_STAIRWAY_PRICE,
            replacement: Price.fromNumber(calculateMonthlyPriceWithoutStairway(state)).toString(),
        };

        return updateDynamicValuesInCmsContent(legalTextStairway, legalTextTokens);
    }
};

export default composeLegalText;
